import React, { useCallback, useState } from 'react';
import AppLayout from '../../component/appLayout';
import { VercelCMDK } from '../../component/vercel';
import Modal from '../../component/modals/modal';
import { ContactUsModal } from '../../component/modals/contactUsmodal';
import { SuccessFullModal } from '../../component/modals/contactUsmodal/successfullModal';
import { isMediaRecordingSupported } from '../../helpers/common';
import SnapRecordModal from '../../component/modals/snapRecordModal';
import UserModal from '../../component/modals/userModal';
import CreateTaskModalV2 from '../../component/modals/createTaskModal';
import ResponsiveHeader from '../../component/responsiveHeader';

const ResponsiveSearch: React.FC = () => {
  // States
  const [isOpenSnapModal, setIsOpenSnapModal] = useState(false);
  const [isOpenTaskModal, setIsOpenTaskModal] = useState(false);
  const [openContactUsModal, setOpenContactUsModal] = useState(false);
  const [isSuccessfullModalOpen, setIsSuccessfullModalOpen] = useState(false);
  const [isOpenUserModal, setIsOpenUserModal] = useState(false);

  const openSnapModal = useCallback(() => {
    setIsOpenSnapModal(true);
  }, []);

  const onClickCreateTask = useCallback(() => {
    setIsOpenTaskModal(true);
  }, []);

  const closeTaskModal = useCallback(() => {
    setIsOpenTaskModal(false);
  }, []);

  const onCloseContactUsModal = useCallback(() => {
    setOpenContactUsModal(false);
  }, []);

  const onCloseSuccessfullModal = useCallback(() => {
    setIsSuccessfullModalOpen(false);
  }, []);

  const closeSnapModal = useCallback(() => {
    setIsOpenSnapModal(false);
  }, []);

  const onClickUserPopup = useCallback(() => {
    setIsOpenUserModal(true);
  }, []);

  const onCloseUserModal = useCallback(() => {
    setIsOpenUserModal(false);
  }, []);
  return (
    <>
      <AppLayout>
        <ResponsiveHeader title='Search' noMargin={true} />
        <VercelCMDK
          openSnapModal={openSnapModal}
          openTaskModal={onClickCreateTask}
          setOpenContactUsModal={() => setOpenContactUsModal(!openContactUsModal)}
          isSearchScreen
          openUserModal={onClickUserPopup}
        />
      </AppLayout>
      <Modal open={isOpenTaskModal} maxWidth={'680px'} onClose={closeTaskModal} isCreateTask={true}>
        <CreateTaskModalV2 onCancel={closeTaskModal} />
      </Modal>
      <Modal open={openContactUsModal} onClose={onCloseContactUsModal} maxWidth={'500px'}>
        <ContactUsModal
          openSuccessFullModal={() => setIsSuccessfullModalOpen(true)}
          closeContactUsModal={() => setOpenContactUsModal(false)}
        />
      </Modal>
      <Modal open={isSuccessfullModalOpen} onClose={onCloseSuccessfullModal} maxWidth={'500px'}>
        <SuccessFullModal onClose={onCloseSuccessfullModal} />
      </Modal>
      {isMediaRecordingSupported() && (
        <Modal open={isOpenSnapModal} onClose={closeSnapModal} maxWidth={'258px'}>
          <SnapRecordModal handleCloseModal={closeSnapModal} />
        </Modal>
      )}
      <Modal open={isOpenUserModal} onClose={onCloseUserModal} maxWidth={'280px'}>
        <UserModal onClose={onCloseUserModal} />
      </Modal>
    </>
  );
};

export default ResponsiveSearch;
